export const FETCH = 'dashboards/FETCH';
export const FETCH_SUCCESS = 'dashboards/FETCH_SUCCESS';
export const FETCH_ERROR = 'dashboards/FETCH_ERROR';

export const CREATE = 'dashboards/CREATE';
export const CREATE_SUCCESS = 'dashboards/CREATE_SUCCESS';
export const CREATE_ERROR = 'dashboards/CREATE_ERROR';

export const UPDATE = 'dashboards/UPDATE';
export const UPDATE_SUCCESS = 'dashboards/UPDATE_SUCCESS';
export const UPDATE_ERROR = 'dashboards/UPDATE_ERROR';

export const SET_CURRENT_BREAKPOINT = 'dashboards/SET_CURRENT_BREAKPOINT';
